/**
 * "Time is up" for a test-kit timer (UC-16): a short double beep (Web Audio, no
 * audio file) and a vibration where the device supports it. Both fail silently —
 * the on-screen notice and the read-aloud text carry the message too.
 */
export function signalTimerDone(): void {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') navigator.vibrate([200, 100, 200]);
  } catch {
    // Vibration blocked: ignore.
  }
  try {
    const Ctx: typeof AudioContext | undefined =
      typeof window === 'undefined'
        ? undefined
        : (window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext);
    if (!Ctx) return;
    const ctx = new Ctx();
    const beep = (at: number): void => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.frequency.value = 880;
      gain.gain.setValueAtTime(0.0001, ctx.currentTime + at);
      gain.gain.exponentialRampToValueAtTime(0.3, ctx.currentTime + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + at + 0.25);
      osc.connect(gain).connect(ctx.destination);
      osc.start(ctx.currentTime + at);
      osc.stop(ctx.currentTime + at + 0.3);
    };
    beep(0);
    beep(0.4);
    setTimeout(() => void ctx.close().catch(() => undefined), 1000);
  } catch {
    // Audio blocked (no user gesture yet): the notice is still shown.
  }
}
